import template from './non-editable-payment-codes.html';

import './non-editable-payment-codes.scss';

const DIRECTIVE_NAME = NonEditablePaymentCodes.DIRECTIVE_NAME = 'ktNonEditablePaymentCodes';
export default function NonEditablePaymentCodes() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: NonEditablePaymentCodesController,
        controllerAs: '$ctrl',
        scope: {
            tripDetails: `=${DIRECTIVE_NAME}`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function NonEditablePaymentCodesController(
    nonEditablePaymentCodesService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        const {tripDetails: {PaymentCodes = [], Travelers: {Adult = []}}} = vm;
        vm.isPerTravellerPaymentCodes = nonEditablePaymentCodesService.isPerTravellerPaymentCodes(PaymentCodes);
        if (vm.isPerTravellerPaymentCodes) {
            vm.travellersWithPaymentCodes = nonEditablePaymentCodesService.formatPerTravellerPaymentCodes(PaymentCodes, Adult);
        } else {
            vm.paymentCodes = PaymentCodes;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/non-editable-payment-codes/non-editable-payment-codes-component.js